namespace $.$$ {
	export class $bog_bzrl_app_nav extends $.$bog_bzrl_app_nav {}
}
